import * as Api from "../../api";
import Utils from "../../untils";
import Vue from "vue";
import {request, requestdel, requestget} from "../../api";
const state = {
  eventsmsg: "",
  mode: "",
  list: {},
  selectedPropertyId: null,
  propertyDtl: null
};

const getters = {
  eventsmsg: state => state.eventsmsg,
  mode: state => state.mode
};

const mutations = {
  change(state, { data }) {
    state.mode = data;
    console.log("mutation state.mode -", state.mode);
  },
  setEventsmsg(state, eventsmsg) {
    state.eventsmsg = eventsmsg;
  },
  setUConnectPropertyDtl( state, {data} ) {
    console.log("mutation state.propertyDtl -", data);
    state.propertyDtl = data;
  },
  setList(state, { data }) {
    state.list = data;
  },
  // 修改收藏状态
  collect(state, { data }) {
    state.list.list.find(v => {
      if (v.propertyId === data.id) {
        if (data.type === "no") {
          v.favoritesFlag = "yes";
        } else {
          v.favoritesFlag = "no";
        }
      }
    });
  },
  collectDetails(state, { data }) {
    if (data === "no") {
      state.propertyDtl.favoritesFlag = "yes";
    } else {
      state.propertyDtl.favoritesFlag = "no";
    }
  },
  setSelectedPropertyId(state, propertyId) {
    state.selectedPropertyId = propertyId;

  },
  clearSelectedPropertyId(state) {
    state.selectedPropertyId = null;
  }
};

const actions = {
  // pdf
  savePdfMsg({ state, rootState }, { pat, callback }) {
    //保存pdf信息
    let obj = {
      action: `/pdf/saveExportSaleAdvice`,
      address: pat.address,
      address2: pat.address2,
      commission: pat.commission,
      contractAgent: pat.contractAgent,
      contractDate: pat.contractDate,
      contractId: pat.contractId,
      depositDate: pat.depositDate,
      dueDateA1: pat.dueDateA1,
      dueDateA2: pat.dueDateA2,
      dueDateB1: pat.dueDateB1,
      dueDateB2: pat.dueDateB2,
      email: pat.email,
      email2: pat.email2,
      fax: pat.fax,
      finance: pat.finance,
      financeDate: pat.financeDate,
      financeDueDate: pat.financeDueDate,
      fullDepositAmount: pat.fullDepositAmount,
      hideBreakdown: pat.hideBreakdown,
      hideDue: pat.hideDue,
      holdingDepositPaid: pat.holdingDepositPaid,
      id: pat.id,
      lenderName: pat.lenderName,
      listingAgent: pat.listingAgent,
      listingId: pat.listingId,
      listingType: pat.listingType,
      phone: pat.phone,
      phone2: pat.phone2,
      referrerCommission1: pat.referrerCommission1,
      referrerCommission2: pat.referrerCommission2,
      referrerCommission3: pat.referrerCommission3,
      referrerTotal: pat.referrerTotal,
      salePrice: pat.salePrice,
      settlement: pat.settlement,
      settlementDate: pat.settlementDate,
      unconditionalDate: pat.unconditionalDate,
      unifiCommission1: pat.unifiCommission1,
      unifiCommission2: pat.unifiCommission2,
      unifiCommission3: pat.unifiCommission3,
      unifiTotal: pat.unifiTotal,
      vendorName: pat.vendorName,
      vendorSolicitorsName: pat.vendorSolicitorsName,
      ordersCommissionPOJOList: pat.commissionList
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "savePdfMsg");
      }
    });
  },
  getPdfMsg({ state, rootState }, { pat, callback }) {
    //获取pdf信息
    let obj = {
      action: `/pdf/findExportSaleAdvice?id=${pat.id}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getPdfMsg");
      }
    });
  },
  savePdfMsgRcti({ state, rootState }, { pat, callback }) {
    //保存pdf信息
    let obj = {
      action: `/pdf/saveExportRcti`,
      id: pat.id,
      recipientAbn: pat.recipientAbn,
      recipientAddressLine1: pat.recipientAddressLine1,
      recipientAddressLine2: pat.recipientAddressLine2,
      recipientName: pat.recipientName,
      recipientPostcode: pat.recipientPostcode,
      recipientState: pat.recipientState,
      recipientSuburb: pat.recipientSuburb,
      supplierAbn: pat.supplierAbn,
      supplierAddressLine1: pat.supplierAddressLine1,
      supplierAddressLine2: pat.supplierAddressLine2,
      supplierName: pat.supplierName,
      supplierPostcode: pat.supplierPostcode,
      supplierState: pat.supplierState,
      supplierSuburb: pat.supplierSuburb,
      supplierBankaccountName: pat.supplierBankaccountName,
      supplierBankaccountBsb: pat.supplierBankaccountBsb,
      supplierBankaccountNumber: pat.supplierBankaccountNumber,
      ordersCommissionPOJOList: pat.commissionList
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "savePdfMsgRcti");
      }
    });
  },
  getPdfMsgRcti({ state, rootState }, { pat, callback }) {
    //获取pdf信息
    let obj = {
      action: `/pdf/findExportRcti?id=${pat.id}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getPdfMsgRcti");
      }
    });
  },

  // 用户模块
  getUserLists({ state, rootState }, { pat, callback }) {
    //首页用户列表
    let obj = {
      action: `/oa/user/findUser/${pat.startTime}/${pat.endTime}/${pat.page}/${pat.size}`
    };
    obj.search = pat.search;
    obj.startTime = pat.startTime;
    obj.endTime = pat.endTime;
    obj.cid = pat.cid;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getUserLists");
      }
    });
  },

  getUConnectUserLists({ state, rootState }, { pat, callback }) {
    //首页用户列表
    let obj = {
      action: `/oa/user/findUConnectUser/${pat.startTime}/${pat.endTime}/${pat.page}/${pat.size}`
    };
    obj.search = pat.search;
    obj.userType = pat.userType;
    obj.startTime = pat.startTime;
    obj.endTime = pat.endTime;
    obj.cid = pat.cid;
    obj.status = pat.status;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getUConnectUserLists", pat.status);
      }
    });
  },

  getSellingAgents({ state, rootState }, { pat, callback }) {
    //首页用户列表
    let obj = {
      action: `/oa/user/findSellingAgent/${pat.startTime}/${pat.endTime}/${pat.page}/${pat.size}`
    };
    obj.search = pat.search;
    obj.startTime = pat.startTime;
    obj.endTime = pat.endTime;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getSellingAgents");
      }
    });
  },

  getRegions({ state, rootState }, { pat, callback }) {
    //首页用户列表
    let obj = {
      action: `/oa/user/findBDM`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getBDMs");
      }
    });
  },
  getFavourites({ state, rootState }, { pat, callback }) {

    let obj = {
      action: `/oa/user/favourites`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getFavorites");
      }
    });
  },
  addToFavourite({ state, rootState }, { pat, callback }) {

    let obj = {
      action: `/oa/user/favourites`
    };
    obj.propertyId = pat.propertyId;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.request(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "addToFavourite", pat.propertyId);
      }
    });
  },
  removeFromFavourite({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/user/favourites?propertyId=${pat.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "removeFromFavourite", pat.propertyId);
      }
    });
  },
  getCompanies({ state, rootState }, { callback }) {
    //获取房源
    let obj = {
      action: `/oa/company/findAllCompanies`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getCompanies");
      }
    });
  },

  // 用户模块
  getHouseSharePasswordLists({ state, rootState }, { pat, callback }) {
    //首页用户列表
    let obj = {
      action: `/oa/houseSharePassword/findHouseSharePassword/${pat.startTime}/${pat.endTime}/${pat.page}/${pat.size}`
    };
    obj.search = pat.search;
    obj.startTime = pat.startTime;
    obj.endTime = pat.endTime;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getHouseSharePasswordLists");
      }
    });
  },

  share({ state, rootState }, { params, callback }) {
    console.log("sharing", params);
    let obj = {
      action: `/oa/house/sharePasswd/email/${params.id}`,
      name: params.data.name,
      email: params.data.email,
      shareName: params.data.shareName
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "share");
      }
    });
  },

  changeSharing({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/house/shareFlag/${pat.propertyId}/${pat.openFlag}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "changeSharing");
      }
    });
  },

  changeSharingPassword({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/house/sharePasswd/${pat.propertyId}`
    };
    obj.passWord = pat.password;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "changeSharingPassword");
      }
    });
  },

  getPropertyDtl2({ state, rootState }, { params, callback }) {
    console.log("getPropertyDtl2", params);
    let obj = {
      action: `/oa/housePublic/${params.id}`,
      passWord: params.password
    };

    if (params.publicFlag === 1) {
      obj.publicFlag = 1;
    }
    if (params.roomId) {
      obj.roomId = params.roomId;
    }

    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getPropertyDtl2");
      }
    });
  },

  getUserDetail({ state, rootState }, { pat, callback }) {
    //获取用户详情
    let obj = {
      action: `/oa/user/getUser/${pat.userId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getUserDetail");
      }
    });
  },

  changeUserType({ state, rootState }, { pat, callback }) {
    //禁用用户
    let obj = {
      action: `/oa/user/suspendUser/${pat.userId}/${pat.status}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "changeUserType");
      }
    });
  },

  deleteUser({ state, rootState }, { pat, callback }) {
    //删除用户
    let obj = {
      action: `/oa/user/delUser/${pat.userId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "deleteUser");
      }
    });
  },

  deleteSharedProperty({ state, rootState }, { pat, callback }) {
    //删除用户
    let obj = {
      action: `/oa/houseSharePassword/delSharedProperty/${pat.id}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "deleteSharedProperty");
      }
    });
  },

  addUser({ state, rootState }, { pat, callback }) {
    //新增用户

    let obj = {
      action: `/oa/user/saveUser`
    };
    obj.abn = pat.abn;
    obj.address = pat.address;
    obj.ccEmail = pat.ccEmail;
    obj.commision = pat.commision;
    obj.companyName = pat.companyName;
    obj.companyId = pat.companyId;
    obj.email = pat.email;
    obj.firstName = pat.firstName;
    obj.lastName = pat.lastName;
    obj.bio = pat.bio;
    obj.imageUrl = pat.imageUrl;
    obj.countryCode = pat.countryCode;
    obj.mobileNumber = pat.mobileNumber;
    obj.phoneNumber = pat.phoneNumber;
    obj.isCompanyAdmin = pat.isCompanyAdmin;
    obj.postcode = pat.postcode;
    obj.state = pat.state;
    obj.suburb = pat.suburb;
    obj.bdm = pat.bdm;
    obj.isUConnect = pat.isUConnect;
    obj.adminRole = pat.adminRole;
    obj.bdmEmail = pat.bdmEmail;
    obj.subscriptionPackageId = pat.subscriptionPackageId;
    obj.doNotSendEmailToUser = pat.doNotSendEmailToUser;
    obj.businessRegistrationNumber = pat.businessRegistrationNumber;
    obj.agentRegistrationNumber = pat.agentRegistrationNumber;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "addUser");
      }
    });
  },

  editUser({ state, rootState }, { pat, callback }) {
    //修改用户
    let obj = {
      action: `/oa/user/updateUser/${pat.userId}`
    };
    console.log("pat.mobileNumber: " + pat.mobileNumber);
    obj.abn = pat.abn;
    obj.address = pat.address;
    obj.ccEmail = pat.ccEmail;
    obj.commision = pat.commision;
    obj.companyName = pat.companyName;
    obj.email = pat.email;
    obj.firstName = pat.firstName;
    obj.lastName = pat.lastName;
    obj.bio = pat.bio;
    obj.isCompanyAdmin = pat.isCompanyAdmin;
    obj.countryCode = pat.countryCode;
    obj.mobileNumber = pat.mobileNumber;
    obj.phoneNumber = pat.phoneNumber;
    obj.postcode = pat.postcode;
    obj.state = pat.state;
    obj.suburb = pat.suburb;
    obj.bdm = pat.bdm;
    obj.password = pat.password;
    obj.bdmEmail = pat.bdmEmail;
    obj.bankaccountName = pat.bankaccountName;
    obj.bankaccountBsb = pat.bankaccountBsb;
    obj.bankaccountNumber = pat.bankaccountNumber;
    obj.imageUrl = pat.imageUrl;
    obj.adminRole = pat.adminRole;
    obj.businessRegistrationNumber = pat.businessRegistrationNumber;
    obj.agentRegistrationNumber = pat.agentRegistrationNumber;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "editUser");
      }
    });
  },

  updatePasswordUser({ state, rootState }, { pat, callback }) {
    //修改用户
    let obj = {
      action: `/oa/user/updatePassword/`
    };

    obj.email = pat.email;
    obj.password = pat.postcode;

    //Vue.http.headers.common = {webType:'store',token:state.token?state.token:Utils.loadLocal2('token')}
    Api.requestput(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "updatePasswordUser");
      }
    });
  },
  getPropertyPdfInfo({ state, rootState }, { pat, callback }) {//获取房源pdf信息
    let obj = {
      action: `/oa/admin/actions-log-statics/${pat.propertyId}/${pat.startTime}/${pat.endTime}`,
    }
    Vue.http.headers.common = { webType: 'store', token: state.token ? state.token : Utils.loadLocal2('token') }
    Api.requestbody(obj).then((resp) => {
      if (callback) {
        callback(resp, 'getPropertyPdfInfo')
      }
    })
  },
  getUserReserved({ state, rootState }, { pat, callback }) {
    //用户预留房产列表
    let obj = {
      action: `/reserved/${pat.userId}/${pat.beginTime}/${pat.endTime}/${pat.page}/${pat.size}`
    };
    obj.keyWord = pat.keyWord;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getUserReserved");
      }
    });
  },

  //FAQ模块
  getFAQLists({ state, rootState }, { pat, callback }) {
    //获取常见问题列表
    let obj = {
      action: `/oa/faq/faqList/${pat.group}/${pat.page}/${pat.size}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getFAQLists");
      }
    });
  },

  getFAQDetail({ state, rootState }, { pat, callback }) {
    //获取常见问题详情
    let obj = {
      action: `/oa/faq/getFaq/${pat.id}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getFAQDetail");
      }
    });
  },

  getAllFaqs({ state, rootState }, { pat, callback }) {
    // get all FAQ's
    let obj = {
      action: `/oa/faq/getAllFaq`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "getAllFaqs");
      }
    });
  },

  addFAQ({ state, rootState }, { pat, callback }) {
    //添加常见问题
    let obj = {
      action: `/oa/faq/saveFaq`
    };
    obj.position = pat.position;
    obj.text = pat.text;
    obj.title = pat.title;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "addFAQ");
      }
    });
  },

  editFAQ({ state, rootState }, { pat, callback }) {
    //修改常见问题
    let obj = {
      action: `/oa/faq/updateFaq`
    };
    obj.position = pat.position;
    obj.text = pat.text;
    obj.title = pat.title;
    obj.id = pat.id;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "editFAQ");
      }
    });
  },

  deleteFAQ({ state, rootState }, { pat, callback }) {
    //删除常见问题
    let obj = {
      action: `/oa/faq/delFaq/${pat.id}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "deleteFAQ");
      }
    });
  },

  //服务商模块
  getServiceLists({ state, rootState }, { pat, callback }) {
    //获取服务商列表
    let obj = {
      action: `/oa/providers/providers/${pat.type}/${pat.page}/${pat.size}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getServiceLists");
      }
    });
  },
  getServiceLists1({ state, rootState }, { pat, callback }) {
    //获取服务商列表
    let obj = {
      action: `/oa/providers/serviceProvidersList`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getServiceLists1");
      }
    });
  },

  deleteService({ state, rootState }, { pat, callback }) {
    //删除服务商
    let obj = {
      action: `/oa/providers/providers/${pat.providersId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteService");
      }
    });
  },

  addService({ state, rootState }, { pat, callback }) {
    //添加服务商
    let obj = {
      action: `/oa/providers/providers`,
      logoUrl: pat.logoUrl,
      position: pat.position,
      providersName: pat.providersName,
      type: pat.type,
      serviceId: pat.serviceId,
      tags: pat.tags,
      url: pat.url
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addService");
      }
    });
  },

  editService({ state, rootState }, { pat, callback }) {
    //修改服务商
    let obj = {
      action: `/oa/providers/providers/${pat.providersId}`,
      logoUrl: pat.logoUrl,
      position: pat.position,
      providersName: pat.providersName,
      serviceId: pat.serviceId,
      type: pat.type,
      tags: pat.tags,
      url: pat.url
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "editService");
      }
    });
  },

  addServiceType({ state, rootState }, { pat, callback }) {
    //添加服务
    let obj = {
      action: `/oa/providers/addServiceProviders`,
      position: pat.position,
      serviceName: pat.providersName
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addServiceType");
      }
    });
  },
  editServiceType({ state, rootState }, { pat, callback }) {
    //修改服务
    let obj = {
      action: `/oa/providers/serviceProviders/${pat.serviceId}`,
      position: pat.position,
      serviceName: pat.providersName
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "editServiceType");
      }
    });
  },
  delServiceType({ state, rootState }, { pat, callback }) {
    //删除服务
    let obj = {
      action: `/oa/providers/delServiceProviders/${pat.serviceId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "delServiceType");
      }
    });
  },
  getServiceTypeList({ state, rootState }, { pat, callback }) {
    //服务列表
    let obj = {
      action: `/oa/providers/serviceProviders/${pat.page}/${pat.size}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getServiceTypeList");
      }
    });
  },

  getServiceDetail({ state, rootState }, { pat, callback }) {
    //获取服务商详情
    let obj = {
      action: `/oa/providers/providers/${pat.providersId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getServiceDetail");
      }
    });
  },

  // 房源列表
  deleteReserve({ state, rootState }, { pat, callback }) {
    //删除预定房间
    let obj = {
      action: `/oa/orders/reservation/${pat.ordersId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "deleteReserve");
      }
    });
  },
  getHouseLists({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/house/house/${pat.lineType}/${pat.page}/${pat.size}`,
      proertyType: pat.proertyType,
      uconnectType: pat.uconnectType,
      search: pat.search,
      agency: pat.agency,
      suburb: pat.suburb
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getHouseLists");
      }
    });
  },
  getLiveReservationsList({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/house/houseList/${pat.lineType}/${pat.page}/${pat.size}`,
      proertyType: pat.proertyType,
      uconnectType: pat.uconnectType,
      search: pat.search,
      agency: pat.agency,
      suburb: pat.suburb
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getLiveReservationsListCallback");
      }
    });
  },

  getSearchDropdown({ state, rootState }, { pat, callback }) {
    //获取房源
    console.log("getSearchDropdown");
    let obj = {
      action: `/oa/house/getsearchdropdown/`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getSearchDropdown");
      }
    });
  },

  getList({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/house/house/${pat.page}/${pat.pageSize}`,
      ...pat.other
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getHouseLists");
      }
    });
  },

  getSearchSuburbsDropdown({ state, rootState }, { pat, callback }) {
    //获取房源
    console.log("getSuburbsSearchDropdown", pat);
    let obj = {
      searchType: pat.searchType,
      action: `/oa/house/house/getSuburbsSearchDropdown`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getSearchSuburbsDropdown");
      }
    });
  },

  getAllStates({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/house/house/getAllStates`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getAllStates");
      }
    });
  },

  deleteAdvertising({ state, rootState }, { pat, callback }) {
    //删除房屋
    let obj = {
      action: `/oa/advertising/delete/${pat.aId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteAdvertising");
      }
    });
  },

  getAds({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/advertising/getAdvertising/`,
      adPage: pat.adPage,
      adSuburbs: pat.adSuburbs
    };

    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getAds");
      }
    });
  },

  getAdvertisingLists({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/advertising/advertising/${pat.page}/${pat.size}`,
      proertyType: pat.proertyType,
      search: pat.search
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getAdvertisingLists");
      }
    });
  },

  getPendingInvoicesForProcessing({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/invoice/getPendingInvoicesForProcessing/${pat.page}/${pat.size}`,
      search: pat.search,
      agency: pat.agency,
      suburb: pat.suburb,
      proertyType: pat.proertyType,
      uconnectType: pat.uconnectType,

      allowInvoice: pat.allowInvoice
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getPendingInvoicesForProcessing");
      }
    });
  },

  processPendingInvoicesForProcessing({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/invoice/processPendingInvoicesForProcessing`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getPendingInvoicesForProcessing");
      }
    });
  },

  getAuthorization({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/authorization/`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getAuthorization");
      }
    });
  },

  sendHalfPriceInvoiceEmails({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/invoice/halfPriceInvoices`
      // search:pat.search,
      // agency:pat.agency,
      // suburb:pat.suburb,
      // proertyType:pat.proertyType,
      // uconnectType:pat.uconnectType,
      // allowInvoice:pat.allowInvoice,
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "sendHalfPriceInvoiceEmails");
      }
    });
  },

  processMobileNumbers({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/admin/process/mobile/format`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "processMobileNumbers");
      }
    });
  },

  getInvoices({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/getInvoices/`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getInvoices");
      }
    });
  },

  updateInvoiceEnabled({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/invoice/updateInvoiceEnabled`,
      propertyId: pat.propertyId,
      allowInvoice: pat.allowInvoice
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "updateInvoiceEnabled");
      }
    });
  },

  getRegionLists({ state, rootState }, { pat, callback }) {
    //Get region lists
    let obj = {
      action: `/oa/region/regionList`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getRegionLists");
      }
    });
  },

  getStateLists({ state, rootState }, { pat, callback }) {
    //Get state lists
    let obj = {
      action: `/oa/state/stateList`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getStateLists");
      }
    });
  },

  getSuburbLists({ state, rootState }, { pat, callback }) {
    // Get suburb lists
    let obj = {
      action: `/oa/suburb/suburbList`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getSuburbLists");
      }
    });
  },

  saveSuburb({ state, rootState }, { pat, callback }) {
    //add a suburb
    let obj = {
      action: `/oa/suburb/saveSuburb`,
      name: pat.suburbVo.name,
      postcode: pat.suburbVo.postcode,
      state: pat.suburbVo.state,
      region: pat.suburbVo.region
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "saveSuburb");
      }
    });
  },

  getCompanyLists({ state, rootState }, { pat, callback }) {
    //获取房源
    let obj = {
      action: `/oa/company/company/${pat.lineType}/${pat.page}/${pat.size}`,
      proertyType: pat.proertyType,
      search: pat.search
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getCompanyLists");
      }
    });
  },

  setHouseReserve({ state, rootState }, { pat, callback }) {
    //预定房源
    let obj = {
      action: `/oa/orders/reservation`,
      ordersCardbagVO: pat.ordersCardbagVO,
      ordersPurchaserLegalVO: pat.ordersPurchaserLegalVO,
      ordersPurchaserVOList: pat.ordersPurchaserVOList,
      agreementDate: pat.agreementDate,
      agreementName: pat.agreementName,
      propertyId: pat.propertyId,
      purchasingEntity: pat.purchasingEntity,
      roomId: pat.roomId,
      userId: pat.userId,
      anticipatedRent: pat.anticipatedRent,
      anticipatedRentMax: pat.anticipatedRentMax,
      apt: pat.apt,
      revisedPrice: pat.revisedPrice,
      referrerPercentage: pat.referrerPercentage
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "setHouseReserve");
      }
    });
  },
  editHouseReserve({ state, rootState }, { pat, callback }) {
    //修改预定房源
    let obj = {
      action: `/oa/orders/reservation/${pat.ordersId}`,
      ordersPurchaserLegalVO: pat.ordersPurchaserLegalVO,
      ordersPurchaserVOList: pat.ordersPurchaserVOList,
      ordersCommissionVOList: pat.ordersCommissionVOList,
      agreementDate: pat.agreementDate,
      agreementName: pat.agreementName,
      purchasingEntity: pat.purchasingEntity,
      checkboxFlag: pat.flag
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "setHouseReserve");
      }
    });
  },

  deleteHouse({ state, rootState }, { pat, callback }) {
    //删除房源
    let obj = {
      action: `/oa/house/house/${pat.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteHouse");
      }
    });
  },

  addHouse({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/house/house`,
      houseFileVo: pat.houseFileVo,
      housePropertyVo: pat.housePropertyVo,
      housePropertyVendorConveyancerVo: pat.housePropertyVendorConveyancerVo,
      houseProvidersVoList: pat.houseProvidersVoList,
      houseVendorVo: pat.houseVendorVo,
      houseVendorLegalVo: pat.houseVendorLegalVo
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addHouse");
      }
    });
  },

  editHouse({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/house/house/${pat.propertyId}`,
      houseFileVo: pat.houseFileVo,
      housePropertyVo: pat.housePropertyVo,
      housePropertyVendorConveyancerVo: pat.housePropertyVendorConveyancerVo,
      houseProvidersVoList: pat.houseProvidersVoList,
      houseVendorVo: pat.houseVendorVo,
      houseVendorLegalVo: pat.houseVendorLegalVo
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "editHouse");
      }
    });
  },

  getPropertyDtl({ state, rootState }, { pat, callback }) {
    console.log("pat", pat);
    let obj = {
      action: `/oa/house/gethouse/${pat.id}/${pat.roomId}/ordersId`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getPropertyDtl");
      }
    });
  },

  updateHouseListingStatus({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/house/house/publish`,
      propertyId: pat.propertyId
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "updateHouseListingStatus");
      }
    });
  },

  addHouseFloorPlan({ state, rootState }, { pat, callback }) {
    //添加房源
    console.log(pat.houseFloorPlansVo);
    let obj = {
      action: `/oa/house/housefloorplan`,
      label: pat.houseFloorPlansVo.label,
      propertyId: pat.houseFloorPlansVo.propertyId,
      floorPlans: pat.houseFloorPlansVo.floorPlans
    };

    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addHouseFloorPlan");
      }
    });
  },

  editHouseFloorPlan({ state, rootState }, { pat, callback }) {
    //修改房源
    console.log("hello");
    let obj = {
      action: `/oa/house/housefloorplan/${pat.propertyId}`,
      houseFloorPlansVo: pat.houseFloorPlansVo
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "editHouseFloorPlan");
      }
    });
  },

  deleteHouseFloorPlan({ state, rootState }, { pat, callback }) {
    //修改房源
    console.log("delete house plan: " + pat.houseFloorPlansVo.floorId);
    let obj = {
      action: `/oa/house/deletefloorplan/${pat.houseFloorPlansVo.floorId}/${pat.houseFloorPlansVo.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteHouseFloorPlan");
      }
    });
  },

  getAdvertDetail({ state, rootState }, { pat, callback }) {
    //

    console.log("aid = " + pat.aId);
    let obj = {
      action: `/oa/advertising/getAdvertising/${pat.aId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getAdvertDetail");
      }
    });
  },

  addAdvertising({ state, rootState }, { pat, callback }) {
    //

    console.log(pat);
    let obj = {
      action: `/oa/advertising/saveAdvertising`,
      id: "",
      advertisingId: pat.advertisingVo.advertisingId,
      agencyId: pat.advertisingVo.agencyId,

      selectedRegion: pat.advertisingVo.selectedRegion,
      selectedState: pat.advertisingVo.selectedState,
      selectedAdPage: pat.advertisingVo.selectedAdPage,
      selectedAdPosition: pat.advertisingVo.selectedAdPosition,

      startDate: pat.advertisingVo.startDate,
      endDate: pat.advertisingVo.endDate,

      imageDesktopUrl: pat.advertisingVo.imageDesktopUrl,
      imageDesktopClickUrl: pat.advertisingVo.imageDesktopClickUrl,
      imageMobileUrl: pat.advertisingVo.imageMobileUrl,
      imageMobileClickUrl: pat.advertisingVo.imageMobileClickUrl
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addAdvertising");
      }
    });
  },

  editAdvertising({ state, rootState }, { pat, callback }) {
    //

    console.log(pat);
    let obj = {
      action: `/oa/advertising/updateAdvertising`,
      id: pat.advertisingVo.id,
      advertisingId: pat.advertisingVo.advertisingId,
      agencyId: pat.advertisingVo.agencyId,

      selectedRegion: pat.advertisingVo.selectedRegion,
      selectedState: pat.advertisingVo.selectedState,
      selectedAdPage: pat.advertisingVo.selectedAdPage,
      selectedAdPosition: pat.advertisingVo.selectedAdPosition,

      startDate: pat.advertisingVo.startDate,
      endDate: pat.advertisingVo.endDate,

      imageDesktopUrl: pat.advertisingVo.imageDesktopUrl,
      imageDesktopClickUrl: pat.advertisingVo.imageDesktopClickUrl,
      imageMobileUrl: pat.advertisingVo.imageMobileUrl,
      imageMobileClickUrl: pat.advertisingVo.imageMobileClickUrl
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "editAdvertising");
      }
    });
  },

  addCompany({ state, rootState }, { pat, callback }) {
    //添加房源
    let obj = {
      action: `/oa/company/saveCompany`,
      companyName: pat.companyVo.companyName,
      address: pat.companyVo.address,
      suburb: pat.companyVo.suburb,
      state: pat.companyVo.state,
      postcode: pat.companyVo.postcode,
      companyEmail: pat.companyVo.companyEmail,
      companyPhone: pat.companyVo.companyPhone,
      companyId: pat.companyVo.companyId,
      companyColour: pat.companyVo.companyColour,
      rla: pat.companyVo.rla,
      isAgency: pat.companyVo.isAgency,
      companyLogoUrl: pat.companyVo.companyLogoUrl,
      companyPhotoUrl: pat.companyVo.companyPhotoUrl,
      membershipStatus: pat.companyVo.membershipStatus,
      billingDate: pat.companyVo.billingDate,
      connectPayment: pat.companyVo.connectPayment,
      connectQuantity: pat.companyVo.connectQuantity
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addCompany");
      }
    });
  },

  editCompany({ state, rootState }, { pat, callback }) {
    //修改房源
    let obj = {
      action: `/oa/company/updateCompany/${pat.Id}`,
      companyId: pat.companyVo.companyId,
      companyName: pat.companyVo.companyName,
      address: pat.companyVo.address,
      suburb: pat.companyVo.suburb,
      state: pat.companyVo.state,
      postcode: pat.companyVo.postcode,
      companyEmail: pat.companyVo.companyEmail,
      companyPhone: pat.companyVo.companyPhone,
      companyColour: pat.companyVo.companyColour,
      rla: pat.companyVo.rla,
      isAgency: pat.companyVo.isAgency,
      companyLogoUrl: pat.companyVo.companyLogoUrl,
      companyPhotoUrl: pat.companyVo.companyPhotoUrl,
      membershipStatus: pat.companyVo.membershipStatus,
      billingDate: pat.companyVo.billingDate,
      connectPayment: pat.companyVo.connectPayment,
      connectQuantity: pat.companyVo.connectQuantity,
      connectStatus: pat.companyVo.connectStatus
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "editCompany");
      }
    });
  },

  deleteCompany({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/company/company/${pat.companyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteCompany");
      }
    });
  },
  getHouseDetail({ state, rootState }, { pat, callback }) {
    //Listing details
    let obj = {
      action: `/oa/house/house/${pat.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getHouseDetail");
      }
    });
  },

  getSessionDetails({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/session-status/${pat.sessionId}`,
      cid: pat.cid,
      uid: pat.uid
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getSessionDetails");
      }
    });
  },

  getMembershipDetails({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/company/membership/${pat.Id}`
    };
    console.log("getMembershipDetails" + pat.Id);
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getMembershipDetails");
      }
    });
  },

  getAgencyDetail({ state, rootState }, { pat, callback }) {
    //房源详情
    let obj = {
      action: `/oa/company/company/${pat.companyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getAgencyDetail");
      }
    });
  },

  getAgencyDetailByInternalId({ state, rootState }, { pat, callback }) {
    //房源详情
    let obj = {
      action: `/oa/company/company2/${pat.id}`
    };
    //console.log("got there")
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getAgencyDetailByInternalId");
      }
    });
  },

  setCompanyDD({ state, rootState }, { pat, callback }) {
    //房源详情
    let obj = {
      action: `/oa/create-checkout-session`,
      membership: pat.stripeSessionVo.membership,
      cid: pat.stripeSessionVo.Id,
      uid: pat.stripeSessionVo.uid
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "setCompanyDD");
      }
    });
  },

  updateCompanyDD({ state, rootState }, { pat, callback }) {
    //房源详情

    let obj = {
      action: `/oa/company/updateCompanyDD/${pat.companyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "updateCompanyDD");
      }
    });
  },

  setCompanyConnectDD({ state, rootState }, { pat, callback }) {
    //房源详情

    let obj = {
      action: `/oa/company/setCompanyConnectDD/${pat.companyId}`,
      cardCvv: pat.ordersCardbagVO.cardCvv,
      cardName: pat.ordersCardbagVO.cardName,
      cardNumber: pat.ordersCardbagVO.cardNumber,
      expMonth: pat.ordersCardbagVO.expMonth,
      expYear: pat.ordersCardbagVO.expYear
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "setCompanyConnectDD");
      }
    });
  },

  updateCompanyConnectDD({ state, rootState }, { pat, callback }) {
    //房源详情

    let obj = {
      action: `/oa/company/updateCompanyConnectDD/${pat.companyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "updateCompanyDD");
      }
    });
  },

  generateStripeInvoice({ state, rootState }, { pat, callback }) {
    //房源详情

    let obj = {
      action: `/oa/company/generateStripeInvoice/${pat.companyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "generateStripeInvoice");
      }
    });
  },

  // 房间管理
  addRoom({ state, rootState }, { pat, callback }) {
    //添加房屋

    // console.log("stampDuty - "  +  pat.stampDuty)
    // console.log("pat.councilRates -" +  pat.councilRates)
    let obj = {
      action: `/oa/room/room`,
      apt: pat.apt, //编号
      status: pat.status, //状态

      beds: pat.beds, //床位
      baths: pat.baths, //浴室
      cars: pat.cars, //车位
      internal: pat.internal, //室内面积
      balcony: pat.balcony, //阳台面积
      total: pat.total, //总面积

      landm2: pat.landm2,
      landPrice: pat.landPrice,
      buildingPrice: pat.buildingPrice,

      totalPriceType: pat.totalPriceType, //
      totalPrice: pat.totalPrice, //
      totalPriceMax: pat.totalPriceMax, //
      anticipatedRentType: pat.anticipatedRentType,
      anticipatedRent: pat.anticipatedRent, //预期租金1
      anticipatedRentMax: pat.anticipatedRentMax, //预期租金2

      floorPlans: pat.floorPlans, //预期租金2

      uconnect: pat.uconnect,
      commission: pat.commission,

      stampDuty: pat.stampDuty,
      lodgement: pat.lodgement,
      councilRates: pat.councilRates,
      titleType: pat.titleType,
      strataFees: pat.strataFees,

      propertyId: pat.propertyId
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addRoom");
      }
    });
  },

  editRoom({ state, rootState }, { pat, callback }) {
    //修改房屋
    console.log(pat.id);
    let obj = {
      action: `/oa/room/room/${pat.roomId}`,

      id: pat.id,
      roomId: pat.roomId,
      apt: pat.apt,
      status: pat.status,
      beds: pat.beds,
      baths: pat.baths,
      cars: pat.cars,
      internal: pat.internal,
      balcony: pat.balcony,
      total: pat.total,
      landm2: pat.landm2,
      landPrice: pat.landPrice,
      buildingPrice: pat.buildingPrice,
      totalPriceType: pat.totalPriceType,
      totalPrice: pat.totalPrice,
      totalPriceMax: pat.totalPriceMax,
      anticipatedRentType: pat.anticipatedRentType,
      anticipatedRent: pat.anticipatedRent,
      anticipatedRentMax: pat.anticipatedRentMax,
      floorPlans: pat.floorPlans,

      uconnect: pat.uconnect,
      commission: pat.commission,

      stampDuty: pat.stampDuty,
      lodgement: pat.lodgement,
      councilRates: pat.councilRates,
      titleType: pat.titleType,
      strataFees: pat.strataFees,

      propertyId: pat.propertyId
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "editRoom");
      }
    });
  },

  addSoldOrReservedListingPropertyRecord({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/room/addRecord/soldOrReservedRoom`,
      ...pat
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "soldListingPropertyRecorded");
      }
    });
  },

  deleteRoom({ state, rootState }, { pat, callback }) {
    //删除房屋
    let obj = {
      action: `/oa/room/room/${pat.roomId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteRoom");
      }
    });
  },

  addUConnectAdvertiseAllRooms({ state, rootState }, { pat, callback }) {
    //删除房屋
    let obj = {
      action: `/oa/room/addUConnectAllRooms/${pat.pId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addUConnectAdvertiseAllRooms");
      }
    });
  },

  deleteUConnectAdvertiseAllRooms({ state, rootState }, { pat, callback }) {
    //删除房屋
    let obj = {
      action: `/oa/room/deleteUConnectAllRooms/${pat.pId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteUConnectAdvertiseAllRooms");
      }
    });
  },

  launchProject({ state, rootState }, { pat, callback }) {
    //删除房屋
    let obj = {
      action: `/oa/house/house/launch/${pat.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "launchProject");
      }
    });
  },

  getLaunchProjectTime({ state, rootState }, { pat, callback }) {
    //删除房屋
    let obj = {
      action: `/oa/house/house/getLaunchTime/${pat.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getLaunchProjectTime");
      }
    });
  },

  getRoomDetail({ state, rootState }, { pat, callback }) {
    //获取房屋信息
    let obj = {
      action: `/oa/room/room/${pat.roomId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getRoomDetail");
      }
    });
  },

  getRoomLists({ state, rootState }, { pat, callback }) {
    //获取房屋列表
    let obj = {
      action: `/oa/room/roomList`,
      propertyId: pat.propertyId,
      ascOrdesc: pat.ascOrdesc,
      orderByKeyword: pat.orderByKeyword
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "getRoomLists");
      }
    });
  },

  // 已预定房产管理
  getReserveLists({ state, rootState }, { pat, callback }) {
    //获取预定房产列表
    let obj = {
      action: `/oa/orders/reserve/${pat.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getReserveLists");
      }
    });
  },

  getFalloverLists({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/orders/fallover/${pat.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getFalloverLists");
      }
    });
  },

  setFallover({ state, rootState }, { pat, callback }) {
    //获取预定房产详情公寓
    let obj = {
      action: `/oa/orders/setfallover/${pat.ordersId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "setFallover");
      }
    });
  },

  getReserveDetail({ state, rootState }, { pat, callback }) {
    //获取预定房产详情公寓
    let obj = {
      action: `/oa/orders/${pat.ordersId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getReserveDetail");
      }
    });
  },

  getReserveDetail1({ state, rootState }, { pat, callback }) {
    //获取预定房产详情非公寓
    let obj = {
      action: `/oa/orders/property/${pat.propertyId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getReserveDetail1");
      }
    });
  },

  eidtReserveType({ state, rootState }, { pat, callback }) {
    //修改预定房产发票状态
    console.log(pat);
    let obj = {
      action: `/oa/orders/invoice/unconditional/${pat.ordersId}`,
      contracePdfUrl: pat.contracePdfUrl,
      formOneUrl: pat.formOneUrl,
      depositPdf: pat.depositPdf,
      saleContractPdf: pat.saleContractPdf,
      sectionPdf: pat.sectionPdf,
      unconditionalAmount: pat.unconditionalAmount,
      unconditionalEndTime: pat.unconditionalEndTime,
      settlemntAmount: pat.settlemntAmount,
      settlemntEndTime: pat.settlemntEndTime,
      deposit2Pdf: pat.deposit2Pdf,
      deposit3Pdf: pat.deposit3Pdf,
      //
      saleContract2Pdf: pat.saleContract2Pdf,
      addition1Pdf: pat.addition1Pdf,
      addition2Pdf: pat.addition2Pdf,
      addition3Pdf: pat.addition3Pdf,
      addition4Pdf: pat.addition4Pdf
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "eidtReserveType");
      }
    });
  },

  // 房源施工管理
  gethouseConstructionList({ state, rootState }, { pat, callback }) {
    //获取施工列表
    let obj = {
      action: `/oa/house/houseConstructionList`,
      propertyId: pat.propertyId
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "gethouseConstructionList");
      }
    });
  },

  addhouseConstruction({ state, rootState }, { pat, callback }) {
    //添加施工日志
    let obj = {
      action: `/oa/house/houseConstruction`,
      propertyId: pat.propertyId,
      description: pat.description,
      attachmentSrc: pat.attachmentSrc,
      attachmentName: pat.attachmentName,
      imageUrl: pat.imageUrl,
      title: pat.title
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "addhouseConstruction");
      }
    });
  },

  edithouseConstruction({ state, rootState }, { pat, callback }) {
    //修改施工日志
    let obj = {
      action: `/oa/house/houseConstruction/${pat.constructionId}`,
      propertyId: pat.propertyId,
      description: pat.description,
      attachmentSrc: pat.attachmentSrc,
      attachmentName: pat.attachmentName,
      imageUrl: pat.imageUrl,
      title: pat.title
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj).then(resp => {
      if (callback) {
        callback(resp, "edithouseConstruction");
      }
    });
  },

  gethouseConstructionDetail({ state, rootState }, { pat, callback }) {
    //施工日志详情
    let obj = {
      action: `/oa/house/houseConstruction/${pat.constructionId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "gethouseConstructionDetail");
      }
    });
  },

  deletehouseConstruction({ state, rootState }, { pat, callback }) {
    //删除施工日志
    let obj = {
      action: `/oa/house/houseConstruction/${pat.constructionId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deletehouseConstruction");
      }
    });
  },

  upBase64Img({ state, rootState }, { pat, callback }) {
    //上传base64图片
    let obj = {
      action: `/oa/admin/uploadAvatar/uploadBase64`,
      picBase64: pat.file
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "upBase64Img");
      }
    });
  },

  getAgentName({ state, rootState }, { pat, callback }) {
    //未读数量
    let obj = {
      action: `/oa/user/user`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getAgentName");
      }
    });
  },

  //消息模块
  getUnReadNum({ state, rootState }, { pat, callback }) {
    //未读数量
    let obj = {
      action: `/oa/Notification/unRead`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getUnReadNum");
      }
    });
  },

  getMsgLists({ state, rootState }, { pat, callback }) {
    //消息列表
    let obj = {
      action: `/oa/Notification/${pat.beginTime}/${pat.endTime}/${pat.page}/${pat.size}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getMsgLists");
      }
    });
  },

  deleteMsg({ state, rootState }, { pat, callback }) {
    //删除消息
    let obj = {
      action: `/oa/Notification/${pat.ids}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteMsg");
      }
    });
  },

  readMsg({ state, rootState }, { pat, callback }) {
    //标记已读消息
    let obj = {
      action: `/oa/Notification/read/multiple`,
      ids: pat.id
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbodys(obj).then(resp => {
      if (callback) {
        callback(resp, "readMsg");
      }
    });
  },

  adList({ state, rootState }, { callback }) {
    let obj = {
      action: `/oa/setup/advertising-details/Ad-Page/list`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "adList");
      }
    });
  },

  adPositionList({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/setup/advertising-details/Ad-position/list`,
      adPage: pat.adPage
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "adPositionList");
      }
    });
  },
  getUConnectPropertyDetails({ state }, { params, callback }) {
    const endpoint = params.ordersId
      ? `/oa/house/house/${params.id}/${params.roomId}/${params.ordersId}`
      : `/oa/house/house/${params.id}/${params.roomId}/ordersId`;

    const obj = { action: endpoint };

    Vue.http.headers.common = {
      webType: "store",
      token: state.token || Utils.loadLocal2('token')
    };

    Api.requestget(obj).then(resp => {
        if (callback) {
          callback(resp, "getUConnectPropertyDetailsCallback");
        }
    });
  },
  getBlogDetail({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/blog/blog/${pat.blogId}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getBlogDetail");
      }
    });
  },
  getBlogList({ state, rootState }, { pat, callback }) {
    let obj = {
      action: `/oa/blog/blogs/${pat.page}/${pat.size}`
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestget(obj).then(resp => {
      if (callback) {
        callback(resp, "getBlogList");
      }
    });
  },
  saveBlogPost({ state, rootState }, { pat, callback }) {

    let obj = {
      action: `/oa/blog/blog`
    };
    obj.title = pat.blogVo.title;
    obj.content = pat.blogVo.content;
    obj.status = pat.blogVo.status;
    obj.publishedOn = pat.blogVo.publishedOn;
    obj.imageUrl = pat.blogVo.imageUrl;
    obj.createdBy = pat.blogVo.createdBy;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "saveBlogPost");
      }
    });
  },
  updateBlogPost({ state, rootState }, { pat, callback }) {
    //修改服务
    let obj = {
      action: `/oa/blog/blog/`
    };
    obj.id = pat.blogVo.id;
    obj.title = pat.blogVo.title;
    obj.content = pat.blogVo.content;
    obj.status = pat.blogVo.status;
    obj.publishedOn = pat.blogVo.publishedOn;
    obj.imageUrl = pat.blogVo.imageUrl;
    obj.createdBy = pat.blogVo.createdBy;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestput(obj, { show: false }).then(resp => {
      if (callback) {
        callback(resp, "updateBlogPost");
      }
    });
  },
  deleteBlogPost({ state, rootState }, { pat, callback }) {
    //删除服务
    let obj = {
      action: `/oa/blog/blog/${pat.blogId}`
    };
    obj.id = pat.id;
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestdel(obj).then(resp => {
      if (callback) {
        callback(resp, "deleteBlogPost");
      }
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/events.js